import clsx from 'clsx';
import React from 'react';
import ReactHtmlParser from 'react-html-parser';

interface TimelineEventProps {
  circleRef: React.RefCallback<HTMLSpanElement>;
  events: { title: string; description: string }[];
  index: number;
  isIntersecting: boolean;
  year: string;
}

const TimelineEvent: React.FC<TimelineEventProps> = ({
  circleRef,
  events,
  index,
  isIntersecting,
  year,
}) => {
  return (
    <div
      className={clsx('flex flex-row items-start justify-center gap-28 sm:gap-48 md:items-center', {
        'md:flex-row-reverse': index % 2 === 0,
      })}
    >
      <span
        className={clsx(
          'm-0 hidden flex-1 font-suisse-intl-mono text-overline-md text-primary-magenta md:block',
          {
            'text-left': index % 2 === 0,
            'text-right': index % 2 !== 0,
          }
        )}
      >
        {year}
      </span>
      <div
        ref={circleRef}
        role="presentation"
        className="z-10 flex h-[22px] w-[22px] items-center justify-center rounded-full border-2 border-solid border-primary-magenta bg-white"
      >
        <span
          className={clsx('h-8 w-8 rounded-full', {
            'bg-primary-pink': !isIntersecting,
            'bg-primary-magenta': isIntersecting,
          })}
        ></span>
      </div>
      <div className="flex-1">
        {events.map(({ title, description }) => (
          <div
            key={title}
            className={clsx('mb-16 text-left last:mb-0', {
              'md:text-right': index % 2 === 0,
            })}
          >
            <span className="block font-suisse-intl-mono text-overline-md text-primary-magenta md:hidden">
              {year}
            </span>
            <h3 className="mb-4 mt-0 font-suisse-works text-headline-xxs text-primary-black [&>a]:text-primary-magenta [&>a]:underline">
              {ReactHtmlParser(title)}
            </h3>
            <p className="my-0 font-suisse-intl text-icon-sm text-primary-black">{description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TimelineEvent;
